export default {
    register: 'api/Login/register',                 //注册
    login: 'api/Login/login',                       //登录
    logout: 'api/Login/logout',                     //登出
    resetpay: 'api/User/resetPay',                  //支付密码
    resetpwd: 'api/User/resetpwd',                  //登录密码
    usrsetreal: 'api/User/usersetReal',             //用户实名
    getusr: 'api/User/getUserInfo',                 //获取用户信息
    getusraddress: 'api/User/getUserWidthAddress',  //获取用户提币地址
    setusraddress: 'api/User/setUserWidthAddress',  //设置用户提币地址
    getUserBalanceList: 'api/User/getUserBalanceList',//获取用户资产详情
    getCoinBalance: 'api/User/getCoinBalance',      //通过币种获取账户余额
    emssend: 'api/Ems/send',    //发送email验证码

    getMarketBalance: 'api/Trade/getMarketBalance', //币币 期权 获取可交易与可卖出数量
    upbbbuy: 'api/Trade/upbbbuy',                   //币币交易
    tradegetOrderList: 'api/Trade/getOrderList',    //获取币币交易记录
    tradecancelOrder: 'api/Trade/cancelOrder',      //撤销委托订单

    getHyConfig: 'api/Contrade/getHyConfig',        //获取合约交易配置
    creatorder: 'api/Contrade/creatorder',          //期权交易下单
    getHyOrderInfo: 'api/Contrade/getHyOrderInfo',  //获取合约订单详情
    getHyOrderList: 'api/Contrade/getHyOrderList',  //获取合约订单列表
    
    transfer: 'api/User/transfer',                  //用户账户划转
    getTransferList: 'api/User/getTransferList',    //用户账户划转记录
    recharge: 'api/User/recharge',                  //用户申请充值
    withdraw: 'api/User/withdraw',                  //申请提现
    getCanWithdrawCoin: 'api/Index/getCanWithdrawCoin', //获取可提现币种
    getUserCoinBalance: 'api/User/getUserCoinBalance', //用户提币-提币地址跟余额
    getBillList: 'api/User/getBillList',            //获取对应账户下币种资金记录
    getWithdrawList: 'api/User/getWithdrawList',    //用户提现记录（单币种
    getRechargeList: 'api/User/getRechargeList',    //用户充值记录（单币种）

    getrecharge: 'api/Index/getRechargeCoinList',   //获取系统支持币种
    uploadfile: 'api/common/upload',                //上传
    getBanner: 'api/index/getBanner',               //获取轮播图
    getMarketList: 'api/index/getMarketList',       //市场列表

    getAllCurrencyList: 'api/index/getAllCurrencyList',//获取行情币种列表
    getAllMarketList: 'api/index/getAllMarketList', //获取行情市场列表

    getCanExchangeCoin: 'api/Balance/getCanExchangeCoin',//获取可以闪兑的币种
    exchangeCoin: 'api/Balance/exchangeCoin',       //闪兑

    searchUser: 'api/Balance/searchUser',           //搜索账号
    getTransferCoin: 'api/Balance/getTransferCoin', //获取当前会员可交易账户与币种配置
    balanceTransfer: 'api/Balance/transfer',               //会员转账提交
    cancelInternalTransfer: 'api/Balance/cancelInternalTransfer',//会员转账取消
    getInternalTransferList: 'api/Balance/getInternalTransferList',//会员转账记录

    getStakingProjects: 'api/Balance/getStakingProjects',   //获取质押项目
    submitStaking: 'api/Balance/submitStaking',     //提交质押
    getStakingOrderList: 'api/Balance/getStakingOrderList', //质押记录
    redeemStaking: 'api/Balance/redeemStaking',     //质押赎回

    getLoanProjects: 'api/Loan/getLoanProjects', //获取贷款项目列表
    applyLoan: 'api/Loan/applyLoan',   //申请贷款
    cancelLoanApply: 'api/Loan/cancelLoanApply', //取消贷款申请
    getLoanRecords: 'api/Loan/getLoanRecords', //获取贷款记录

    getMiningMachineList: 'api/Machine/getMiningMachineList',//获取矿机列表 id传的话只返回一条
    buyMiningMachine: 'api/Machine/buyMiningMachine',//  购买矿机   id amount
    getMiningMachineOrders: 'api/Machine/getMiningMachineOrders',// 矿机购买记录

    getNoticeList: 'api/User/getNoticeList', //获取用户通知
    
    getUserBankList: 'api/User/getUserBankList',  //获取用户银行卡列表  
    setBank: 'api/User/setBank',                //编辑银行卡

    getSetting: 'api/index/index',                  //网站配置信息
    getLangList: 'api/index/getLangList',           //获取语言列表
    setLang: 'api/index/setLang',                   //设置当前语言
    getFriendList: 'api/index/getFriendList',       //有商链接
    getContentList: 'api/index/getContentList', //获取内容
    getHuoBiTradeFromRedis: 'api/index/getHuoBiTradeFromRedis', //获取市场最新交易记录
    getHuoBiAllTradeFromRedis: 'api/index/getHuoBiAllTradeFromRedis', //获取市场最新交易记录
    getUserStakingInfo: 'api/Balance/getUserStakingInfo',
    findUsrPwd: 'api/login/forgetPwd'
}
